konnyScript(function($){
    $('#knPrdCon .bibFreeEvent').click(function(){
        $('#knPrdCon .bibFreePopUp').addClass('active');
        $('body').addClass('popOpen');
    });
    $('#knPrdCon .bibFreePopUp .bgLayer').click(function(){
        $('#knPrdCon .bibFreePopUp').removeClass('active');
        $('body').removeClass('popOpen');
    });
    $('#knPrdCon .bibFreePopUp .closeBt').click(function(){
        $('#knPrdCon .bibFreePopUp').removeClass('active');
        $('body').removeClass('popOpen');
    });
    
    $('#knPrdCon .qnaInfo header').click(function(){
        $(this).toggleClass('active');
    });
    
    
    //몰컷 슬라이드_25FW
    $('[id^="mall_26ss_swiper_slide"]').each(function(index){
        var slideScr = this.querySelector('.swiper-scrollbar');
        var mallSlide = new Swiper(this,{
            slidesPerView:'auto',
            slidesPerGroup:1,
            spaceBetween:10,
            centeredSlides:false,
            scrollbar:{
                el:slideScr,
            },
        });
    });

    /* gif 슬라이드 */
    $('[id^="bgGif_swiper_slide"]').each(function(index){
        var gifSlide = new Swiper(this,{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            effect:'fade',
            speed:0,
            autoplay:{
                delay:600,
                disableOnInteraction:false,
            },
        });
    });
    

    function adjustThumbPosition(swiper, activeIndex) {
        const total = swiper.slides.length;
        if (total <= 3) return;

        if (activeIndex <= 1) {
            swiper.slideTo(0, 300);
            return;
        }

        if (activeIndex >= total - 2) {
            swiper.slideTo(total - 3, 300);
            return;
        }

        swiper.slideTo(activeIndex - 1, 300);
    }

    function initProductGallery(scope) {

        if (typeof Swiper === 'undefined') {
            console.log('Swiper not loaded');
            return;
        }

        scope.querySelectorAll('.prdGallery').forEach(function (gallery) {

            if (gallery.dataset.swiperInit === "true") return;
            gallery.dataset.swiperInit = "true";

            const thumbEl = gallery.querySelector('.prdGalleryThumb');
            const mainEl  = gallery.querySelector('.prdGalleryMain');

            if (!thumbEl) return;

            // 🔥 슬라이드 개수 체크
            const slideCount = thumbEl.querySelectorAll('.swiper-slide').length;
            const scrollbarEl = thumbEl.querySelector('.swiper-scrollbar');

            const thumbs = new Swiper(thumbEl, {
                slidesPerView: 3.45,
                spaceBetween: 10,
                watchSlidesProgress: true,
                observer: true,
                observeParents: true,
                resizeObserver: true,
                scrollbar: slideCount > 3 ? {
                    el: scrollbarEl,
                    draggable: true,
                    hide: false,
                } : false,
            });

            // 🔥 3개 이하일 경우 스크롤바 숨김
            if (slideCount <= 3 && scrollbarEl) {
                scrollbarEl.style.display = 'none';
            }

            if (mainEl) {
                const main = new Swiper(mainEl, {
                    speed: 300,
                    loop: false,
                    observer: true,
                    observeParents: true,
                    thumbs: {
                        swiper: thumbs,
                    },
                    on: {
                        slideChange: function () {
                            adjustThumbPosition(thumbs, this.activeIndex);
                        }
                    }
                });
            }

            thumbs.on('click', function () {
                if (thumbs.clickedIndex == null) return;
                adjustThumbPosition(thumbs, thumbs.clickedIndex);
            });

        });
    }

    window.addEventListener('load', function () {
        initProductGallery(document);
    });

    document.addEventListener('shopify:section:load', function (e) {
        initProductGallery(e.target);
    });

});
